import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, {
        username,
        password
      });

      if (response.data.success) {
        // Store both the login flag and JWT token
        localStorage.setItem('admin_logged_in', 'true');
        localStorage.setItem('admin_token', response.data.token);
        toast.success('Login correcte');
        navigate('/admin/dashboard');
      }
    } catch (error) {
      console.error('Error login:', error);
      if (error.response?.status === 429) {
        toast.error('Massa intents. Espera un minut i torna-ho a provar.');
      } else {
        toast.error('Credencials incorrectes');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-6 py-12 bg-muted/30">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md"
      >
        <div className="bg-card rounded-2xl shadow-sm border border-border/50 p-8">
          <div className="flex justify-center mb-8">
            <div className="w-16 h-16 bg-primary/10 text-primary rounded-full flex items-center justify-center">
              <Lock className="h-8 w-8" />
            </div>
          </div>

          <h1 className="font-heading text-3xl font-medium text-center text-foreground mb-2">
            Administració
          </h1>
          <p className="text-center text-muted-foreground mb-8">
            Inicia sessió per gestionar els productes
          </p>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="username" className="text-lg mb-2">Usuari</Label>
              <Input
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                data-testid="admin-username"
                className="h-14 rounded-xl text-lg"
                required
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-lg mb-2">Contrasenya</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password"
                className="h-14 rounded-xl text-lg"
                required
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              data-testid="admin-login-button"
              className="w-full h-14 text-lg font-semibold rounded-xl"
            >
              {loading ? 'Entrant...' : 'Entrar'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <Link 
              to="/admin/request-reset" 
              className="text-sm text-muted-foreground hover:text-primary transition-colors"
            >
              Has oblidat la contrasenya?
            </Link>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default AdminLogin;